import { makeStyles } from '@material-ui/core'
import React from 'react'
import { useMemo } from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { UserPermissions } from 'web/src/services/permissions'
import { generatePassword, getRoleName } from 'web/src/utils'
import { Button, Input, Picker } from '../../root/components/common'
import { LOCALE_MAP } from '../../root/constants'

export const UserDetails = ({
    email,
    user,
    updateUser,
    updateRole,
    disabled,
    rolesMap
}) => {
    const styles = useStyles()
    const { locale } = useSelector(state => state.main)
    const [isChangePassword, setIsChangePassword] = useState(false)
    const localeOptions = useMemo(() => makeOptions(LOCALE_MAP), [])

    const allRoles = useSelector(state =>
        state.userManagement.roles
            ? state.userManagement.roles.reduce((acc, role) => {
                  acc[role.id] = getRoleName(role, locale)
                  return acc
              }, {})
            : null
    )

    return (
        <div className={styles.root}>
            <div
                style={{
                    marginBottom: 40,
                    fontSize: 20,
                    letterSpacing: '-1.6px',
                    fontWeight: 'bold'
                }}
            >
                {locale.common.settings}
            </div>
            <div>
                <Input
                    className={styles.input}
                    type="text"
                    disabled={disabled}
                    setValue={v => updateUser({ name: v })}
                    value={user.user.name}
                    label={locale.common.name}
                />
            </div>
            <div className={styles.row}>
                <Input
                    className={styles.input}
                    type="text"
                    disabled
                    label={locale.common.email}
                    value={email}
                />
            </div>
            <Picker
                key={user.user.language}
                className={styles.picker}
                disablePortal
                disabled={disabled}
                options={localeOptions}
                onChange={v => updateUser({ language: v })}
                value={user.user.language}
            />
            <div className={styles.section}>
                <div className={styles.rolesTitle}>{locale.common.role}</div>
                <Picker
                    key={user.user.role_id}
                    className={styles.picker}
                    disabled={!UserPermissions.isUserMgmtGranted()}
                    options={allRoles}
                    onChange={v => updateUser({ role_id: v })}
                    value={user.user.role_id}
                />
            </div>
            {!disabled ? (
                <div className={styles.row}>
                    {isChangePassword ? (
                        <>
                            <Input
                                className={styles.input}
                                label={locale.common.password}
                                value={user.user.password}
                                disabled={true}
                            />
                            <Button
                                onClick={() =>
                                    updateUser({ password: generatePassword() })
                                }
                            >
                                {locale.userManagement.genPassword}
                            </Button>
                        </>
                    ) : (
                        <Button disa onClick={() => setIsChangePassword(true)}>
                            {locale.userManagement.changePassword}
                        </Button>
                    )}
                </div>
            ) : null}
        </div>
    )
}

const makeOptions = localeMap => {
    for (const [key, value] of Object.entries(localeMap)) {
        localeMap[key] = value.toUpperCase()
    }
    return localeMap
}

const useStyles = makeStyles(theme => ({
    picker: {
        height: 50
    },
    row: {
        display: 'flex'
    },
    root: {
        width: 500,
        '&& > :not(:last-child)': {
            marginBottom: 24
        },
        marginRight: 70,
        borderRight: theme.border
    },
    input: {
        maxWidth: 400
    }
}))
